<template>
  <v-container>
    <div class="mic_container">
      <v-form
        ref="form"
        lazy-validation
        class="mic_form">
        <v-toolbar
          card
          color="#5ba322"
          dark
          class="mic_form-spacer">
          <v-toolbar-title>Motivations-Fragebogen</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div style="margin: 25px 0 0 25px!important">
          <div class="v-messages theme--light">
            <div class="v-messages__wrapper">
              <div class="v-messages__message">
                <h2>{{introductionInfo}}</h2>
              </div>
              <br>
              <br>
              <div class="v-messages__message">
                <h2>{{callToFillOut}}</h2>
              </div>
            </div>
          </div>
        </div>
        <div class="mic_form-content">
          <v-layout>
            <v-flex
              xs12
              md6>
              <v-menu
                ref="motivationDataMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px">
              </v-menu>
            </v-flex>
          </v-layout>
        </div>
        <v-toolbar
          card
          color="#5ba322"
          dark
          class="mic_form-spacer">
          <v-toolbar-title>Mein konkretes Fernziel</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div class="mic_form-content">
          <v-layout>
            <v-flex
              xs12
              md6>
              <v-text-field
                v-model="weightLoss.value"
                :disabled="disabled == true"
                label="Gewichtsreduktion in kg"
                type="number"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div id='Fernziel'>
                <input style="margin: 25px 0 0 0"
                       type="checkbox"
                       id="jointPain"
                       :disabled="disabled == true"
                       v-model="jointPain">
                <v-label for="jointPain">Gelenkschmerzen / Übergewichtsschäden verringern</v-label>
                <br>
  <!--              <input style="margin: 25px 0 0 0"-->
  <!--                     type="checkbox"-->
  <!--                     id="reduceDiabetesMedication"-->
  <!--                     :disabled="disabled == true"-->
  <!--                     v-model="reduceDiabetesMedication">-->
  <!--              <v-label for="reduceDiabetesMedication">Diabetes Medikamente verringern</v-label>-->
  <!--              <br>-->
  <!--              <input style="margin: 25px 0 0 0"-->
  <!--                     type="checkbox"-->
  <!--                     id="getRidOfInsulin"-->
  <!--                     :disabled="disabled == true"-->
  <!--                     v-model="getRidOfInsulin">-->
  <!--              <v-label for="getRidOfInsulin">Insulin loswerden</v-label>-->
  <!--              <br>-->
  <!--              <input style="margin: 25px 0 0 0"-->
  <!--                     type="checkbox"-->
  <!--                     id="avoidComplications"-->
  <!--                     :disabled="disabled == true"-->
  <!--                     v-model="avoidComplications">-->
  <!--              <v-label for="avoidComplications">Komplikationen des Diabetes vermeiden</v-label>-->
  <!--              <br>-->
  <!--              <input style="margin: 25px 0 0 0"-->
  <!--                     type="checkbox"-->
  <!--                     id="healDiabetes"-->
  <!--                     :disabled="disabled == true"-->
  <!--                     v-model="healDiabetes">-->
  <!--              <v-label for="healDiabetes">Diabetes heilen</v-label>-->
                <input style="margin: 25px 0 0 0"
                       type="checkbox"
                       id="preventDiabetes"
                       :disabled="disabled == true"
                       v-model="preventDiabetes">
                <v-label for="preventDiabetes">Diabetes vorbeugen</v-label>
                <br>
                <input style="margin: 25px 0 0 0"
                       type="checkbox"
                       id="increaseFitness"
                       :disabled="disabled == true"
                       v-model="increaseFitness">
                <v-label for="increaseFitness">Körperliche Fitness steigern</v-label>
                <br>
                <input style="margin: 25px 0 0 0"
                       type="checkbox"
                       id="climbStairs"
                       :disabled="disabled == true"
                       v-model="climbStairs">
                <v-label for="climbStairs">Normal Treppen steigen können</v-label>
                <br>
                <input style="margin: 25px 0 0 0"
                       type="checkbox"
                       id="canPlay"
                       :disabled="disabled == true"
                       v-model="canPlay">
                <v-label for="canPlay">Mit den Kindern / Freunden (Ball) spielen können</v-label>
                <br>
                <input style="margin: 25px 0 0 0" type="checkbox" id="furtherFarTargets"
                       :disabled="disabled == true" v-model="furtherFarTargets">
                <v-label for="furtherFarTargets">Sonstige Fernziele</v-label>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div
                style="padding: 25px 0 0 25px"
                v-show="furtherFarTargets"
                v-for="(furtherFarTargetsItem, index) in furtherFarTargetsItems"
                v-bind:key="furtherFarTargetsItem.id + index"
                v-bind:message="furtherFarTargetsItem.message"
                v-on:remove="furtherFarTargetsItem.splice(index, 1)">
                <div style="margin-bottom: 25px;">
                  <h3>Sonstiges Fernziel {{index+1}}</h3>
                  <v-text-field
                    style="margin-top: 0!important;"
                    :disabled="disabled == true"
                    v-model=furtherFarTargetsItem.target
                    label="Fernziel"
                    :messages=furtherFarTargetsItem.message>
                  </v-text-field>
                </div>
              </div>
              <s v-show="furtherFarTargets"
                     color="#f5a900"
                     @click="addFurtherFarTarget"
                     :disabled="disabled == true"
                     class="white--text">Weiteres Fernziel hinzufügen
              </s>
            </v-flex>
          </v-layout>
        </div>
        <v-toolbar
          card
          color="#5ba322"
          dark
          class="mic_form-spacer">
          <v-toolbar-title>Meine konkreten Nahziele</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div class="mic_form-content">
          <v-layout>
            <v-flex
              xs12
              md6>
              <div>
                <input style="margin: 25px 0 0 0"
                       type="checkbox"
                       id="weeklyWeightLoss"
                       :disabled="disabled == true"
                       v-model="weeklyWeightLoss">
                <v-label for="weeklyWeightLoss">0,5 – 1 kg Gewichtsreduktion pro Woche</v-label>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <input class="mic_double-item-input-row"
                     style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="leaveOffSugar"
                     :disabled="disabled == true"
                     v-model="leaveOffSugar">
              <v-label for="leaveOffSugar">Zucker weglassen</v-label>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <v-text-field
                class="mic_double-item-input-row"
                :disabled="disabled == true"
                v-model="leaveOffFurther"
                label="bzw. Sonstiges weglassen">
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <input style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="dailyMovement"
                     :disabled="disabled == true"
                     v-model="dailyMovement"
                     :rules="dailyMovementRules">
              <v-label for="dailyMovement">Bewegung in Minuten am Tag</v-label>
            </v-flex>
          </v-layout>
          <v-layout v-if="dailyMovement === true">
            <v-flex
              xs12
              md6>
              <v-text-field
                :disabled="disabled == true"
                v-model="dailyMovementMinutes"
                type="number"
                min="0"
                placeholder="z.B. 50"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <input style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="furtherNearTargets"
                     :disabled="disabled == true"
                     v-model="furtherNearTargets">
              <v-label for="furtherNearTargets">Sonstige Nahziele</v-label>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div
                style="padding: 25px 0 0 25px!important"
                v-show="furtherNearTargets"
                v-for="(furtherNearTargetsItem, index) in furtherNearTargetsItems"
                v-bind:key="furtherNearTargetsItem.id + index"
                v-on:remove="furtherNearTargetsItem.splice(index, 1)">
                <div style="margin-bottom: 25px;">
                  <h3>Sonstiges Nahziel {{index+1}}</h3>
                  <v-text-field
                    style="margin-top: 0!important;"
                    :disabled="disabled == true"
                    v-model=furtherNearTargetsItem.name
                    label="Nahziel">
                  </v-text-field>
                </div>
              </div>
              <v-btn v-show="furtherNearTargets" color="#f5a900" @click="addFurtherNearTarget" class="white--text" :disabled="disabled == true">
                Weiteres Nahziel hinzufügen
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
        <v-toolbar card color="#5ba322" dark class="mic_form-spacer">
          <v-toolbar-title>Meine Hauptmotivation:</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-radio-group style="margin: 25px 0 25px 25px"
                       :disabled="disabled == true"
                       v-model="mainMotivation"
                       label="Motivation">
          <v-radio label="Kommt von mir, ist mein eigener Wunsch"
                   value="kommt von mir, ist mein eigener Wunsch"></v-radio>
          <v-radio label="wird vor allem von Partner(in) / Freunden / Chef / Arzt ausgelöst"
                   value="wird vor allem von Partner(in)/Freunden/Chef/Arzt ausgelöst"></v-radio>
        </v-radio-group>
        <v-toolbar
          card
          color="#5ba322"
          dark
          class="mic_form-spacer">
          <v-toolbar-title>Was hat mich bisher gehindert?</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div class="mic_form-content">
          <v-layout>
            <v-flex
              xs12
              md6>
              <input class="mic_double-item-input-row"
                     style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="hungerAttackTVnight"
                     :disabled="disabled == true"
                     v-model="hungerAttackTVnight">
              <v-label for="hungerAttackTVnight">Hungerattacke vor dem Fernseher, nachts</v-label>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <input class="mic_double-item-input-row"
                     style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="foodInBetween"
                     :disabled="disabled == true"
                     v-model="foodInBetween">
              <v-label for="foodInBetween">Hunger zwischendurch</v-label>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <input class="mic_double-item-input-row"
                     style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="foodAsConsolation"
                     :disabled="disabled == true"
                     v-model="foodAsConsolation">
              <v-label for="foodAsConsolation">Essen als Trost</v-label>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <input class="mic_double-item-input-row"
                     style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="foodByFrustration"
                     :disabled="disabled == true"
                     v-model="foodByFrustration">
              <v-label for="foodByFrustration">Essen bei Frust</v-label>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <input class="mic_double-item-input-row"
                     style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="foodAsReward"
                     :disabled="disabled == true"
                     v-model="foodAsReward">
              <v-label for="foodAsReward">Essen als Belohnung</v-label>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <input class="mic_double-item-input-row"
                     style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="foodAgainstBoredom"
                     :disabled="disabled == true"
                     v-model="foodAgainstBoredom">
              <v-label for="foodAgainstBoredom">Essen gegen Langeweile</v-label>
            </v-flex>
          </v-layout>
          <v-subheader class="mic_subheader">
            Wovon werde ich schwach? Wo kann ich nicht widerstehen?
          </v-subheader>
          <v-layout>
            <v-flex
              xs12
              md6>
              <input class="mic_double-item-input-row"
                     style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="noSweetsResistance"
                     :disabled="disabled == true"
                     v-model="noSweetsResistance">
              <v-label for="noSweetsResistance">Süßigkeiten / Schokolade</v-label>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <input class="mic_double-item-input-row"
                     style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="furtherWeaknesses"
                     :disabled="disabled == true"
                     v-model="furtherWeaknesses">
              <v-label for="furtherWeaknesses">Sonstige Schwächen</v-label>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div
                style="padding: 0 25px 0 25px!important"
                v-show="furtherWeaknesses"
                v-for="(furtherWeaknessesItem, index) in furtherWeaknessesItems"
                v-bind:key="furtherWeaknessesItem.id + index"
                v-on:remove="furtherWeaknessesItems.splice(index, 1)">
                <div style="margin: 25px 0 25px 0;">
                  <h3>Sonstige Schwäche {{index+1}}</h3>
                  <v-text-field
                    style="margin-top: 0!important;"
                    :disabled="disabled == true"
                    v-model=furtherWeaknessesItem.name
                    label="Schwäche">
                  </v-text-field>
                </div>
              </div>
              <v-btn v-show="furtherWeaknesses"
                     color="#f5a900"
                     @click="addFurtherWeaknesses"
                     :disabled="disabled == true"
                     class="white--text">Weitere
                Schwäche hinzufügen
              </v-btn>
            </v-flex>
          </v-layout>
          <v-subheader class="mic_subheader">
            Meine Kalorienfallen im Glas:
          </v-subheader>
          <v-layout>
            <v-flex
              xs12
              md6>
              <input class="mic_double-item-input-row"
                     style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="glassCaloriesBeer"
                     :disabled="disabled == true"
                     v-model="glassCaloriesBeer">
              <v-label for="glassCaloriesBeer">Bier</v-label>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <input class="mic_double-item-input-row"
                     style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="glassCaloriesJuice"
                     :disabled="disabled == true"
                     v-model="glassCaloriesJuice">
              <v-label for="glassCaloriesJuice">Fruchtsäfte</v-label>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <input class="mic_double-item-input-row"
                     style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="glassCaloriesCola"
                     :disabled="disabled == true"
                     v-model="glassCaloriesCola">
              <v-label for="glassCaloriesCola">Cola / Limonade</v-label>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <input class="mic_double-item-input-row"
                     style="margin: 25px 0 0 0"
                     type="checkbox"
                     id="glassCaloriesAlcohol"
                     :disabled="disabled == true"
                     v-model="glassCaloriesAlcohol">
              <v-label for="glassCaloriesAlcohol">Wein / Alkohol</v-label>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <input class="mic_double-item-input-row" style="margin: 25px 0 0 0" type="checkbox"
                     :disabled="disabled == true"
                     id="glassCaloriesOtherCheckbox" v-model="glassCaloriesOtherCheckbox">
              <v-label for="glassCaloriesOtherCheckbox">Sonstige Kalorienfallen</v-label>
            </v-flex>
          </v-layout>
          <v-layout v-if="glassCaloriesOtherCheckbox === true">
            <v-flex
              xs12
              md6>
              <v-text-field
                label="Sonstige Kalorienfallen"
                :rules=glassCaloriesOtherRules
                :disabled="disabled == true"
                class="mic_double-item-input-row" v-model="glassCaloriesOther">
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <v-text-field
                :disabled="disabled == true"
                v-model="frustrationFood"
                label="Was esse ich bei Frust?">
              </v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <v-toolbar card color="#5ba322" dark class="mic_form-spacer">
          <v-toolbar-title>Meine Wahrnehmung:</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-radio-group
          style="margin: 25px 0 0 25px"
          :disabled="disabled == true"
          v-model="fedUpNotice"
          label="Merke ich, dass ich satt bin: z.B. es ist jetzt genug, ich bin nun satt.">
          <v-radio label="ja" value="ja"></v-radio>
          <v-radio label="vielleicht" value="vielleicht"></v-radio>
          <v-radio label="nein, nie" value="nein, nie"></v-radio>
        </v-radio-group>
        <v-radio-group
          style="margin: 0 0 0 25px"
          :disabled="disabled == true"
          v-model="fedUpAfterBreadSlides"
          label="Nach wie viel Scheiben Brot bin ich satt?">
          <v-radio label="1 Scheibe" value="1 Scheibe Brot"></v-radio>
          <v-radio label="2 Scheiben" value="2 Scheiben"></v-radio>
          <v-radio label="3 Scheiben" value="3 Scheiben"></v-radio>
          <v-radio label="4 Scheiben" value="4 Scheiben"></v-radio>
          <v-radio label="5 Scheiben" value="5 Scheiben"></v-radio>
        </v-radio-group>
        <v-layout>
          <v-flex
            xs12
            md6>
            <v-text-field
              style="margin: 0 0 0 25px"
              :disabled="disabled == true"
              v-model="satisfyingFood"
              label="Welches Essen macht mich wirklich satt und zufrieden?">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-subheader class="mic_subheader">
          Wann merke ich, dass ich satt bin:
        </v-subheader>
        <v-radio-group
          style="margin: 0 0 0 25px"
          :disabled="disabled == true"
          v-model="howNoticeFedUp"
          label="Wann bin ich satt? Nach:">
          <v-radio label="Völlegefühl" value="Völlegefühl"></v-radio>
          <v-radio label="der Teller ist leer" value="der Teller ist leer"></v-radio>
          <v-radio label="Sonstiges" value=""></v-radio>
        </v-radio-group>
        <v-layout v-if="howNoticeFedUp === ''">
          <v-flex xs12 md6>
            <v-text-field
              style="margin: 0 0 0 25px"
              label="Sonstige Sättigungsmerkmale"
              :disabled="disabled == true"
              v-model="howNoticeFedUpFurther">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md6>
            <v-text-field
              style="margin: 0 0 0 25px"
              label="Welches Essen tut mir gut?"
              :disabled="disabled == true"
              v-model="foodDoWell">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-radio-group
          style="margin: 25px 0 0 25px"
          :disabled="disabled == true"
          v-model="enjoymentOfFoodTaste" label="Ich habe Genuss beim Schmecken des Essens">
          <v-radio label="ja" value="ja"></v-radio>
          <v-radio label="selten" value="selten"></v-radio>
          <v-radio label="nein, nie" value="nein, nie"></v-radio>
        </v-radio-group>
        <v-radio-group style="margin: 25px 0 0 25px" v-model="increaseEnjoyment"
                       :disabled="disabled == true"
                       label="Ich kann den Genuss erhöhen durch: ">
          <v-radio label="bewusst kauen und schmecken" value="bewusst kauen und schmecken"></v-radio>
          <v-radio label="langsam essen" value="langsam essen"></v-radio>
          <v-radio label="auf den Appetit warten, erst dann essen"
                   value="auf den Appetit warten, erst dann essen"></v-radio>
        </v-radio-group>
        <div class="mic_form-content">
          <v-btn color="#f5a900" @click="save" class="white--text " :disabled="disabled == true">Speichern</v-btn>
        </div>
      </v-form>
    </div>
  </v-container>
</template>

<script>
import {motivationService} from '../_services'
import {trackingService} from '../_services'
export default {
  data () {
    return {
      disabled: false,
      introductionInfo: 'Großartig, dass du dich entschieden hast, nun aktiv etwas für deine Gesundheit zu tun.',
      callToFillOut: 'Damit wir von MindCarb dich dabei ganz individuell auf der Basis deiner eigenen Ziele, Wünsche und Umstände unterstützen können, bitten wir dich nun, uns erst noch folgende Fragen zu beantworten:',
      weightLoss: {
        value: ''
      },
      jointPain: false,
      reduceDiabetesMedication: false,
      getRidOfInsulin: false,
      furtherFarTargets: false,
      avoidComplications: false,
      foodAsConsolation: false,
      foodByFrustration: false,
      frustrationFood: '',
      foodAgainstBoredom: false,
      foodAsReward: false,
      healDiabetes: false,
      preventDiabetes: false,
      increaseFitness: false,
      climbStairs: false,
      canPlay: false,
      weeklyWeightLoss: false,
      leaveOffSugar: false,
      dailyMovement: false,
      fedUpNotice: null,
      fedUpAfterBreadSlides: null,
      increaseEnjoyment: null,
      enjoymentOfFoodTaste: null,
      satisfyingFood: '',
      mainMotivation: null,
      foodInBetween: false,
      glassCaloriesBeer: false,
      glassCaloriesJuice: false,
      glassCaloriesCola: false,
      howNoticeFedUp: null,
      glassCaloriesAlcohol: false,
      noSweetsResistance: false,
      hungerAttackTVnight: false,
      glassCaloriesOtherCheckbox: false,
      glassCaloriesOther: '',
      dailyMovementMinutes: '',
      foodDoWell: '',
      leaveOffFurther: '',
      howNoticeFedUpFurther: '',
      furtherFarTargetsItems: [
        {
          id: 'farTarget0',
          message: 'Sonstiges Fernziel'
        }
      ],
      furtherNearTargets: false,
      furtherNearTargetsItems: [
        {
          id: 'nearTarget0',
          message: 'Sonstiges Nahziel'
        }
      ],
      furtherWeaknesses: false,
      furtherWeaknessesItems: [
        {
          id: 'weakness0',
          message: 'Sonstige Schwäche'
        }
      ],
      dailyMovementMinutesRules: [
        v => ((this.dailyMovement.checked) ? v !== '' : v === '') || 'Minuten am Tag ist ein Pflichtfeld, wenn Sie Bewegung ausgewählt haben'
      ],
      dailyMovementRules: [],
      glassCaloriesOtherRules: []
    }
  },
  beforeMount () {
    motivationService.getMotivation(JSON.parse(localStorage.getItem('user')).id)
      .then(
        response => {
          this.disabled = true
          this.weightLoss = response.data.weightLoss
          this.jointPain = response.data.jointPain
          this.reduceDiabetesMedication = response.data.reduceDiabetesMedication
          this.getRidOfInsulin = response.data.getRidOfInsulin
          this.avoidComplications = response.data.avoidComplications
          this.foodAsConsolation = response.data.foodAsConsolation
          this.foodByFrustration = response.data.foodByFrustration
          this.frustrationFood = response.data.frustrationFood
          this.foodAgainstBoredom = response.data.foodAgainstBoredom
          this.foodAsReward = response.data.foodAsReward
          this.healDiabetes = response.data.healDiabetes
          this.preventDiabetes = response.data.preventDiabetes
          this.increaseFitness = response.data.increaseFitness
          this.climbStairs = response.data.climbStairs
          this.canPlay = response.data.canPlay
          this.weeklyWeightLoss = response.data.weeklyWeightLoss
          this.leaveOffSugar = response.data.leaveOffSugar
          this.dailyMovement = response.data.dailyMovement
          this.fedUpNotice = response.data.fedUpNotice || ''
          this.fedUpAfterBreadSlides = response.data.fedUpAfterBreadSlides
          this.increaseEnjoyment = response.data.increaseEnjoyment
          this.enjoymentOfFoodTaste = response.data.enjoymentOfFoodTaste
          this.satisfyingFood = response.data.satisfyingFood
          this.mainMotivation = response.data.mainMotivation
          this.foodInBetween = response.data.foodInBetween
          this.glassCaloriesBeer = response.data.glassCaloriesBeer
          this.glassCaloriesJuice = response.data.glassCaloriesJuice
          this.glassCaloriesCola = response.data.glassCaloriesCola
          this.howNoticeFedUp = response.data.howNoticeFedUp || ''
          this.glassCaloriesAlcohol = response.data.glassCaloriesAlcohol
          this.noSweetsResistance = response.data.noSweetsResistance
          this.hungerAttackTVnight = response.data.hungerAttackTVnight
          this.glassCaloriesOtherCheckbox = !!response.data.glassCaloriesOther
          this.glassCaloriesOther = response.data.glassCaloriesOther
          this.dailyMovementMinutes = response.data.dailyMovementMinutes
          this.foodDoWell = response.data.foodDoWell
          this.leaveOffFurther = response.data.leaveOffFurther
          this.howNoticeFedUpFurther = response.data.howNoticeFedUpFurther
          this.furtherFarTargets = response.data.furtherFarTargets.length > 0
          this.furtherFarTargetsItems = !response.data.furtherFarTargets ? [
            {
              id: 'farTarget0',
              message: 'Sonstiges Fernziel'
            }
          ] : response.data.furtherFarTargets
          this.furtherNearTargets = response.data.furtherNearTargets.length > 0
          this.furtherNearTargetsItems = !response.data.furtherNearTargets ? [
            {
              id: 'nearTarget0',
              message: 'Sonstiges Nahziel'
            }
          ] : response.data.furtherNearTargets
          this.furtherWeaknesses = response.data.furtherWeaknesses.length > 0
          this.furtherWeaknessesItems = !response.data.furtherWeaknesses ? [
            {
              id: 'weakness0',
              message: 'Sonstige Schwäche'
            }
          ] : response.data.furtherWeaknesses
        },
        error => {
          console.log(error)
        }
      )
  },
  methods: {
    save () {
      const {dispatch} = this.$store
      console.log(this.furtherFarTargetsItems)
      var cleanedFurtherFarTargetsItems
      if (!this.furtherFarTargets) {
        cleanedFurtherFarTargetsItems = []
      } else {
        cleanedFurtherFarTargetsItems = []
        for (var i = 0; i < this.furtherFarTargetsItems.length; i++) {
          if (this.furtherFarTargetsItems[i].target) {
            var formattedFurtherFarTargetsItem = {
              message: this.furtherFarTargetsItems[i].message,
              id: this.furtherFarTargetsItems[i].id,
              target: this.furtherFarTargetsItems[i].target
            }
            cleanedFurtherFarTargetsItems.push(formattedFurtherFarTargetsItem)
          }
        }
      }
      console.log(cleanedFurtherFarTargetsItems)
      var cleanedFurtherNearTargetsItems
      if (!this.furtherNearTargets) {
        cleanedFurtherNearTargetsItems = []
      } else {
        cleanedFurtherNearTargetsItems = []
        for (var j = 0; j < this.furtherNearTargetsItems.length; j++) {
          if (this.furtherNearTargetsItems[j].name) {
            var formattedFurtherNearTargetsItem = {
              message: this.furtherNearTargetsItems[j].message,
              name: this.furtherNearTargetsItems[j].name,
              id: this.furtherNearTargetsItems[j].id
            }
            cleanedFurtherNearTargetsItems.push(formattedFurtherNearTargetsItem)
          }
        }
      }
      var cleanedFurtherWeaknessesTargetsItems
      if (!this.furtherWeaknesses) {
        cleanedFurtherWeaknessesTargetsItems = []
      } else {
        cleanedFurtherWeaknessesTargetsItems = []
        for (var k = 0; k < this.furtherWeaknessesItems.length; k++) {
          if (this.furtherWeaknessesItems[k].name) {
            var formattedFurtherWeaknessItem = {
              message: this.furtherWeaknessesItems[k].message,
              name: this.furtherWeaknessesItems[k].name,
              id: this.furtherWeaknessesItems[k].id
            }
            cleanedFurtherWeaknessesTargetsItems.push(formattedFurtherWeaknessItem)
          }
        }
      }
      let motivation = {
        weightLoss: this.weightLoss,
        jointPain: this.jointPain,
        reduceDiabetesMedication: this.reduceDiabetesMedication,
        getRidOfInsulin: this.getRidOfInsulin,
        avoidComplications: this.avoidComplications,
        healDiabetes: this.healDiabetes,
        preventDiabetes: this.preventDiabetes,
        increaseFitness: this.increaseFitness,
        climbStairs: this.climbStairs,
        canPlay: this.canPlay,
        furtherFarTargets: cleanedFurtherFarTargetsItems,
        weeklyWeightLoss: this.weeklyWeightLoss,
        leaveOffSugar: this.leaveOffSugar,
        leaveOffFurther: this.leaveOffFurther,
        reduceFurther: this.reduceFurther,
        furtherNearTargets: cleanedFurtherNearTargetsItems,
        dailyMovement: this.dailyMovement,
        dailyMovementMinutes: this.dailyMovementMinutes,
        mainMotivation: this.mainMotivation || '',
        hungerAttackTVnight: this.hungerAttackTVnight,
        foodInBetween: this.foodInBetween,
        foodAsConsolation: this.foodAsConsolation,
        foodByFrustration: this.foodByFrustration,
        foodAsReward: this.foodAsReward,
        foodAgainstBoredom: this.foodAgainstBoredom,
        noSweetsResistance: this.noSweetsResistance,
        furtherWeaknesses: cleanedFurtherWeaknessesTargetsItems,
        glassCaloriesBeer: this.glassCaloriesBeer,
        glassCaloriesJuice: this.glassCaloriesJuice,
        glassCaloriesCola: this.glassCaloriesCola,
        glassCaloriesAlcohol: this.glassCaloriesAlcohol,
        glassCaloriesOther: this.glassCaloriesOther,
        frustrationFood: this.frustrationFood,
        fedUpNotice: this.fedUpNotice || '',
        fedUpAfterBreadSlides: this.fedUpAfterBreadSlides || '',
        satisfyingFood: this.satisfyingFood,
        howNoticeFedUp: this.howNoticeFedUp || '',
        howNoticeFedUpFurther: this.howNoticeFedUpFurther,
        foodDoWell: this.foodDoWell,
        enjoymentOfFoodTaste: this.enjoymentOfFoodTaste || '',
        increaseEnjoyment: this.increaseEnjoyment || '',
        userId: JSON.parse(localStorage.getItem('user')).id
      }
      motivationService.saveMotivation(motivation)
        .then(
          response => {
            dispatch('alert/success', 'Motivationsfragebogen wurde erfolgreich gespeichert.', {root: true})
            trackingService.getProfile(JSON.parse(localStorage.getItem('user')).id)
              .then(
                res => {
                  this.$router.push('/welcome')
                },
                () => {
                  this.$router.push('/profile')
                })
          },
          error => {
            console.log(error)
            dispatch('alert/error', 'Fehler beim Speichern des Motivationsfragebogens.', {root: true})
          }
        )
    },
    addFurtherFarTarget () {
      this.furtherFarTargetsItems.push({
        id: 'furtherFarTargets' + this.furtherFarTargetsItems.length,
        target: '',
        message: 'Sonstiges Fernziel'
      })
    },
    addFurtherNearTarget () {
      this.furtherNearTargetsItems.push({
        id: 'furtherNearTargets' + this.furtherNearTargetsItems.length,
        name: '',
        message: 'Sonstiges Nahziel'
      })
    },
    addFurtherWeaknesses () {
      this.furtherWeaknessesItems.push({
        id: 'furtherNearTargets' + this.furtherWeaknessesItems.length,
        name: '',
        message: 'Sonstiges Schwächen'
      })
    }
  }
}
</script>

<style scoped="true">
  .mic_subheader {
    margin-top: 50px;
  }

  .mic_double-item-input-row {
    padding-right: 25px;
  }

</style>



// WEBPACK FOOTER //
// src/motivation/MotivationPage.vue